const observe_carousels = function() {
    const carousels = document.querySelectorAll('.carousel');
    let flktys = [];
    let group;
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    let cellAlign;

    const init_carousel = (carousel) => {
        if (is_mobile()) {
            group = 1 
        }else{
            group = 1
            if (carousel.querySelectorAll('.carousel-cell').length <= parseInt(carousel.dataset.min)) {return false}
        }
    	let wrapper = carousel.closest('.carousel-wrapper')
        let arrows=false;
        if (carousel.dataset.arrows) {
            arrows=true;
        }
    	let flkty = new Flickity( carousel, {
		  cellAlign: cellAlign,
		  contain: true,
		  pageDots: true,
		  wrapAround: true,
          prevNextButtons:arrows,
          groupCells: group,
		});
        flkty.on( 'change', function( index ){
        	wrapper.style.setProperty('color',flkty.cells[index].element.dataset.color)
        });
        flktys.push({ flkty });
    }

    carousels.forEach(carousel => {
        init_carousel(carousel)
    })
    const reset_carousels = () => {
        flktys.forEach(({flkty}) =>{
            flkty.destroy();
        })
        cellAlign = mobileQuery.matches ? "center" : "left";
        carousels.forEach(carousel => {
            init_carousel(carousel)
        })
    };
    reset_carousels();
    mobileQuery.addEventListener("change", () => {
        reset_carousels();
    });
    this.disconnect = () =>{
    	flktys.forEach(({flkty}) =>{
            flkty.destroy();
    	})
    }
    this.reset = () => {
        reset_carousels()
    }
};